<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header bg-light">
                <div class="card-header--title">
                    <small>Statistics</small>
                    <b>Last quarter report</b>
                </div>
                <div class="card-header--actions">
                    <a [routerLink]="" class="btn btn-sm btn-first" tooltip="View details">
                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                    </a>
                </div>
            </div>
            <div class="pt-3">
                <div class="row mt-3 mb-2">
                    <div class="col">
                        <div class="text-center">
                            <div>
                                <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-success"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg">2,345</b>
                                <span class="text-black-50 d-block">users</span>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="text-center">
                            <div>
                                <fa-icon [icon]="['far', 'keyboard']" class="font-size-xxl text-danger"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg">3,568</b>
                                <span class="text-black-50 d-block">clicks</span>
                            </div>
                        </div>
                    </div>
                </div>

                <apx-chart
                        [chart]="{
                        type: 'area',
                        height: '150',
                        sparkline: {
                          enabled: true
                        }
                    }"
                        [colors]="['#f83245']"
                        [fill]="{
                        color: '#f83245',
                        gradient: {
                            shade: 'light',
                            type: 'vertical',
                            shadeIntensity: 0.7,
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 0,
                            stops: [0, 100]
                        }
                    }"
                        [series]="[
                      {
                        name: 'Monthly Analytics',
                        data: [47, 56, 45, 54, 24, 38,  24, 38, 56, 65]
                      }
                    ]"
                        [stroke]="{
                        color: '#1bc943',
                        curve: 'smooth',
                        width: 4
                    }"
                        [xaxis]="{
                        crosshairs: {
                            width: 1
                        }
                    }"
                        [yaxis]="{
                        min: 0
                    }"
                ></apx-chart>
            </div>
            <div class="p-4 text-center">
                <button class="btn btn-outline-primary mb-1" type="button">
                    <span class="btn-wrapper--label">
                        View complete report
                    </span>
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header bg-light">
                <div class="card-header--title">
                    <small>Statistics</small>
                    <b>Users overview</b>
                </div>
                <div class="card-header--actions">
                    <a [routerLink]="" class="btn btn-link btn-link-primary p-0 font-size-xl text-primary" tooltip="View options">
                        <fa-icon [icon]="['fas', 'ellipsis-h']"></fa-icon>
                    </a>
                </div>
            </div>
            <div class="card-body pb-0">
                <div class="align-box-row">
                    <div class="font-weight-bold">
                        <small class="text-black-50 d-block mt-2 mb-2 text-uppercase">New Accounts</small>
                        <span class="font-size-xxl ">586,356</span>
                    </div>
                    <div class="ml-auto">
                        <div class="bg-first text-center text-white font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'building']"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="mt-1">
                    <fa-icon [icon]="['fas', 'arrow-up']" class="text-danger"></fa-icon>
                    <span class="text-success px-1">15.4%</span>
                    <span class="text-black-50">increase this month</span>
                </div>
                <div class="mt-4">
                    <button class="btn btn-pill btn-outline-primary mb-3" type="button">
                        <span class="btn-wrapper--label">
                            View complete report
                        </span>
                        <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
                    </span>
                    </button>
                </div>
            </div>
            <apx-chart
                    [chart]="{
                        type: 'area',
                        height: '172',
                        sparkline: {
                          enabled: true
                        }
                    }"
                    [colors]="['#1bc943']"
                    [fill]="{
                        color: '#4191ff',
                        gradient: {
                            shade: 'light',
                            type: 'vertical',
                            shadeIntensity: 0.7,
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 0,
                            stops: [0, 100]
                        }
                    }"
                    [series]="[
                      {
                        name: 'Monthly Analytics',
                        data: [47, 38, 56, 24, 45, 54, 38, 56, 24, 65]
                      }
                    ]"
                    [stroke]="{
                        color: '#1bc943',
                        curve: 'smooth',
                        width: 4
                    }"
                    [xaxis]="{
                        crosshairs: {
                            width: 1
                        }
                    }"
                    [yaxis]="{
                        min: 0
                    }"
            ></apx-chart>
        </div>
    </div>
</div>
